import { useMemo } from 'preact/hooks'
import { useAthosContext } from '../fetchers/provider'
import { useOption } from '../hooks/useOption'
import Icon from '@/components/snippets/icon/icon'
import clsx from 'clsx'

export function FilterSort({ name = 'sort', buttonClass = 'underline btn btn-text-black btn-sm btn-inline whitespace-nowrap', direction = 'down' }) {
  const { results, refine } = useAthosContext()

  const sorts = useMemo(() => {
    return (
      results?.sorting?.options?.map((option) => ({
        label: option.label,
        value: `${option.field}:${option.direction}`
      })) ?? []
    )
  }, [results])

  const activeSort = useOption('sort', {
    defaultValue: sorts?.[0]?.value,
    syncWithURL: true
  })

  const activeSortLabel = useMemo(() => {
    const sort = sorts.find((sort) => sort.value === activeSort) ?? sorts[0]
    return sort?.label
  }, [activeSort, sorts])

  return (
    <x-modal className="relative group" data-id="sort">
      <button data-modal-role="toggle" data-modal-parent="sort" className={buttonClass}>
        <Icon id="arrow-up-down" />
        <div className="flex">
          <span>Sort By</span>
          <span className="hidden md:block">: {activeSortLabel}</span>
        </div>
      </button>
      <button
        data-modal-role="close"
        data-modal-parent="sort"
        className="pointer-events-none fixed inset-0 z-max bg-black/60 opacity-0 transition-all group-data-visible:pointer-events-auto group-data-visible:opacity-100 md:z-30"
        aria-label="Close sort"
      />
      <div
        className={clsx(
          'pointer-events-none fixed inset-6 z-max flex flex-col overflow-hidden rounded-lg bg-primary-white opacity-0 transition-all',
          'group-data-visible:pointer-events-auto group-data-visible:opacity-100',
          'md:absolute md:inset-auto md:right-0 md:z-40 md:max-h-0 md:w-80 md:rounded-none md:opacity-100',
          'md:group-data-visible:max-h-96',
          direction === 'down' ? 'md:top-full' : 'md:bottom-full'
        )}
      >
        <div className="relative flex h-full w-full flex-col overflow-y-auto bg-primary-white transition-all -translate-x-4 group-data-visible:translate-x-0 md:translate-x-0 md:group-data-visible:translate-x-0">
          <div className="flex justify-between px-4 py-2 pr-1 md:p-6">
            <p className="my-auto h4">Sort</p>
            <button data-modal-role="close" data-modal-parent="sort" className="btn btn-md btn-icon btn-inline" aria-label="Close sort">
              <Icon id="close" />
            </button>
          </div>
          <div className="px-4 py-4 md:px-6 md-max:border-t md-max:border-neutrals-light-grey">
            {sorts?.map((sort) => (
              <div className="mb-6 flex h-6 items-center gap-2">
                <input
                  id={`sort__${sort.value}`}
                  type="radio"
                  value={sort.value}
                  name={name}
                  onClick={() => {
                    refine('sort', sort.value)
                    refine('page', 1)
                  }}
                  checked={activeSort === sort.value}
                  className="field-radio"
                />
                <label for={`sort__${sort.value}`} className="paragraph-md text-neturals-secondary-grey">
                  {sort.label}
                </label>
              </div>
            ))}
          </div>
        </div>
      </div>
    </x-modal>
  )
}
